module.exports = __webpack_public_path__ + "img/页头.d24b4f34.jpg";